<template>
  <qx-custom-form
    :noSubBtn="true"
    ref="baseForm"
    :formData="baseForm"
    labelWidth="120px"
  >
    <span slot="paymentWayTip" style="margin-left: 16px" slot-scope="prop">
      <span class="error" v-if="prop.form.paymentWay === 2"
        >现金部分的费用会生成车辆费用申请</span
      >
    </span>
  </qx-custom-form>
</template>

<script>
import {
  etcManageList,
} from 'api/service';
export default {
  props: {
    initData: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    initData: {
      immediate: true,
      handler (newValue) {
        this.$nextTick(() => {
          newValue.id = newValue.id || 0;
          newValue.state = newValue.state || 0;
          newValue.stateName = newValue.stateName || '';
          newValue.paymentWay = newValue.paymentWay ? Number(newValue.paymentWay) : 3;
          newValue.cardNo = newValue.cardNo || '';
          newValue.file = newValue.file || [];
          this.otherFormData = newValue;
          this.$refs.baseForm.setVal(newValue);
        });
      },
    },
  },
  data () {
    return {
      otherFormData: {},
      baseForm: {
        form: [
          {
            label: 'id',
            value: 'id',
            type: 'input',
            disabled: false,
            hide: true,
            // default: this.initData.id || 0,
          },
          {
            label: '上报状态',
            value: 'state',
            type: 'input',
            disabled: false,
            hide: true,
            // default: this.initData.state || 0,
          },
          {
            label: '上报状态名',
            value: 'stateName',
            type: 'input',
            disabled: false,
            hide: true,
            // default: this.initData.stateName || '',
          },

          {
            label: '消费金额',
            value: 'amount',
            type: 'input',
            disabled: false,
            // default: this.initData.amount,
          },
          {
            label: '消费时间',
            value: 'subTime',
            type: 'date',
            disabled: false,
            attr: { type: 'datetime', time: '00:00:00' },
            // default: this.initData.subTime,
          },
          {
            label: '支付方式',
            value: 'paymentWay',
            type: 'select',
            disabled: false,
            // default: this.initData.paymentWay ? Number(this.initData.paymentWay) : 3,
            options: [
              {
                label: 'ETC卡',
                value: 3,
              },
              {
                label: '现金',
                value: 2,
              },
            ],
            onChange: () => {
              this.handlePaymentWayChange();
            },
          },
          // {
          //   label: '卡号',
          //   value: 'cardNo',
          //   type: 'input',
          //   hide: false,
          // },
          {
            label: '卡号',
            value: 'cardNo',
            type: 'el-autocomplete',
            valueKey: 'etcId',
            hide: false,
            disabled: false,
            querySearchAsync: (queryString, cb) => {
              let result = [];
              if (queryString && queryString.length) {
                etcManageList({ etcId: queryString }).then((res) => {
                  if (res && res.items) {
                    result = res.items;
                  }
                  cb(result);
                });
              }
              cb(result);
            },
          },
          {
            label: '上传附件',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            disabled: false,
            attr: {
              limit: 3,
            },
            // default: this.initData.file || [],
          },
          {
            label: '备注',
            value: 'remark',
            type: 'input',
            disabled: false,
            attr: {
              type: 'textarea',
            },
            // default: this.initData.remark,
          },
        ],
        rules: {
          amount: [ // 消费金额
            { required: true, message: '请输入消费金额', trigger: 'blur' },
          ],
          // 【2022042201】处理费用上报时--消费时间必填   --By liuyanming
          subTime: [ // 消费时间
            { required: true, message: '请选择消费时间', trigger: 'blur' },
          ],
          paymentWay: [ // 支付方式
            { required: true, message: '请选择支付方式', trigger: 'blur' },
          ],
          file: [ // 上传附件
            { required: true, message: '请选择上传附件', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    handlePaymentWayChange () {
      const paymentWay = this.$refs.baseForm.getVal('paymentWay');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: paymentWay !== 3,
        names: ['cardNo'],
      });
      this.$emit('handlePaymentWayChange', paymentWay);
    },
    setDisabledByState (disabled) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: disabled,
      });
    },
    setRequiredByState (required) {
      this.setFormRuleAttr({
        rules: this.baseForm.rules,
        attr: 'required',
        value: required,
      });
    },
    async getVal () {
      const res = await this.$refs.baseForm.getVal();
      const formData = {
        ...this.otherFormData,
        ...res,
      };
      return formData;
    },
    async sub () {
      const res = await this.$refs.baseForm.sub();
      const formData = {
        ...this.otherFormData,
        ...res,
      };
      return formData;
    },
    mounted () {
      this.handlePaymentWayChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
